/* eslint-disable */
module.exports = [
    {
        path: '/',
        component: () => import(/* webpackChunkName: "home" */ '@/views/HomeLayout.vue'),
        children: [
          {
            path: '/',
            alias: 'home',
            component: () => import(/* webpackChunkName: "home" */ '@/views/website/StartPage')
          },
          {
            path: 'login',
            alias: '/login',
            component: () => import(/* webpackChunkName: "home" */ '@/views/website/LoginPage')
          },
          {
            path: 'logout',
            alias: '/logout',
            component: () => import(/* webpackChunkName: "home" */ '@/views/website/LogoutPage')
          },
          {
            path: 'register',
            alias: '/register',
            component: () => import(/* webpackChunkName: "home" */ '@/views/website/LoginPage'),
            meta: { sitemap: { ignoreRoute: true } }
          },
          {
            path: 'checklogin',
            alias: '/checklogin',
            component: () => import(/* webpackChunkName: "home" */ '@/views/website/CheckLoginPage')
          },
          {
            path: 'eventlist',
            alias: '/eventlist',
            component: () => import(/* webpackChunkName: "home" */ '@/views/website/EventsPage'),
            meta: { requiresAuth: true }
          },
          {
            path: 'eventselect',
            alias: '/eventselect',
            component: () => import(/* webpackChunkName: "home" */ '@/views/website/EasyEventSelectionPage'),
            meta: { requiresAuth: true, sitemap: { ignoreRoute: true } }
          },
          {
            path: 'resetpassword',
            alias: '/reset-password',
            component: () => import(/* webpackChunkName: "home" */ '@/views/website/ResetPasswordPage')
          },
          {
            path: 'impressum',
            alias: '/impressum',
            component: () => import(/* webpackChunkName: "home" */ '@/views/website/ImpressumPage')
          },
          {
            path: 'agb',
            alias: '/agb',
            component: () => import(/* webpackChunkName: "home" */ '@/views/website/AgbPage')
          },
          {
            path: 'datenschutz',
            alias: '/datenschutz',
            component: () => import(/* webpackChunkName: "home" */ '@/views/website/DatenschutzPage')
          },
        ]
      },
      {
        path: '/event',
        component: () => import(/* webpackChunkName: "home" */ '@/views/EventLayout.vue'),
        meta: {
          requiresAuth: true,
          sitemap: { ignoreRoute: true }
        },
        children: [
          {
            path: 'overview',
            alias: '/',
            component: () => import(/* webpackChunkName: "home" */ '@/views/dashboard/TasksPage.vue'),
          },
          {
            path: ':id',
            redirect: ':id/tasks',
            component: () => import(/* webpackChunkName: "home" */ '@/views/dashboard/TasksPage.vue'),
          },
          {
            path: ':id/tasks/:showmap?',
            component: () => import(/* webpackChunkName: "home" */ '@/views/dashboard/TasksPage.vue'),
          },
          {
            path: ':id/map',
            name:'map',
            component: () => import(/* webpackChunkName: "home" */ '@/views/dashboard/TasksPage.vue'),
          },
          {
            path: ':id/inactive',
            component: () => import(/* webpackChunkName: "home" */ '@/views/dashboard/InactiveEventPage')
          },
          {
            path: ':id/settings/:section?',
            name: 'settings',
            component: () => import(/* webpackChunkName: "home" */ '@/views/dashboard/SettingsPage.vue'),
            // app-level page: the event layout leaves out its header and footer
            meta: { appLevel: true },
          },
          {
            path: ':id/info',
            alias: 'info',
            component: () => import(/* webpackChunkName: "home" */ '@/views/dashboard/InfoPage.vue'),
          },
          {
            path: ':id/welcome',
            alias: 'welcome',
            component: () => import(/* webpackChunkName: "home" */ '@/views/dashboard/WelcomeDialogPage.vue'),
          },
          {
            path: ':id/highscore',
            alias: 'highscore',
            component: () => import(/* webpackChunkName: "home" */ '@/views/dashboard/HighscorePage.vue'),
          },
          {
            path: ':id/data',
            alias: 'data',
            component: () => import(/* webpackChunkName: "home" */ '@/views/dashboard/IframePage.vue'),
          },
          {
            path: ':id/gallery',
            alias: 'gallery',
            component: () => import(/* webpackChunkName: "home" */ '@/views/dashboard/GalleryPage.vue'),
          },
          {
            path: ':id/evidence',
            alias: 'evidence',
            component: () => import(/* webpackChunkName: "home" */ '@/views/dashboard/EvidencePage.vue'),
          },
          {
            path: ':id/draw',
            alias: 'draw',
            component: () => import(/* webpackChunkName: "home" */ '@/views/dashboard/DrawingPage.vue'),
          },
          {
            path: ':id/custompage/:page_id',
            alias: 'custompage',
            component: () => import(/* webpackChunkName: "home" */ '@/views/dashboard/CustomPage.vue'),
          },
        ]
      },
      { path: "*",
      component: () => import(/* webpackChunkName: "home" */ '@/views/PageNotFound.vue')}
]
